<!--政策法规-->
<template>
    <div class="studio_nav_content">
        <div class="content-container" v-show="showMode==='page'">
            <div class="tj-container">
                <div :class="category?'tj-item':'tj-item-active'" @click="changeCategory('')">全部</div>
                <div :class="category==='1'?'tj-item-active':'tj-item'" @click="changeCategory('1')">教育</div>
                <div :class="category==='2'?'tj-item-active':'tj-item'" @click="changeCategory('2')">科技</div>
                <div :class="category==='3'?'tj-item-active':'tj-item'" @click="changeCategory('3')">知识产权</div>
            </div>
            <div class="tj-container">
                <div :class="subcategory?'tj-item':'tj-item-active'" @click="changeSubcategory('')">全部</div>
                <div :class="subcategory==='1'?'tj-item-active':'tj-item'" @click="changeSubcategory('1')">国务院文件</div>
                <div :class="subcategory==='2'?'tj-item-active':'tj-item'" @click="changeSubcategory('2')">国务院部门文件</div>
            </div>
            <div class="right-container">
                <div class="info-list-container">
                    <div class="zc-item" v-for="item in dataList" :key="item.zhengcId">
                        <div class="zc-title" @click="viewZhengc(item)">{{item.title}}</div>
                        <div class="zc-content" @click="viewZhengc(item)">{{item.wordContent}}</div>
                        <div class="tag-content">
                            <div class="tag-type" v-if="item.subcategory==='1'">国务院文件</div>
                            <div class="tag-type" v-if="item.subcategory==='2'">国务院部门</div>
                            <div class="tag-time">{{ timestampDate(item.releaseTime) }}</div>
                        </div>
                    </div>
                    <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                </div>
                <div class="page-container" >
                    <pageTag :background="true"
                             :pageSizes="[10, 20, 30]"
                             :total="total"
                             v-model:page.sync="queryParams.pageNum"
                             v-model:limit.sync="queryParams.pageSize"
                             @pagination="pageList" />
                </div>
            </div>
        </div>

        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <zhengc-info :zhengc-id="this.zhengcId"
                         @change-mode="changeModel"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import {timestampDate} from "@/utils/date";
import pageTag from "@/components/Pagination/page.vue";
import {pageZhengc} from "@/api/admin/zhengc"
import zhengcInfo from "@/components/resourceCentre/zhengcInfo.vue";

export default {
    name:'zcfgResource',
    components:{zhengcInfo, pageTag, dataEmpty},
    props:{
        courseMode:{
            type: String,
            default:'page'
        },
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    mounted() {
        this.pageList()
    },
    data() {
        return {
            showMode:'page',
            category:'',
            subcategory:'',
            timestampDate,
            queryParams: {
                category:'',
                subcategory:'',
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            zhengcId:'',
        }
    },
    methods: {
        pageList(){
            this.queryParams.category = this.category
            this.queryParams.subcategory = this.subcategory
            pageZhengc(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changeCategory(val){
            this.category = val;
            this.queryParams.category = val;
            this.pageList();
        },
        changeSubcategory(val){
            this.subcategory = val;
            this.queryParams.subcategory = val;
            this.pageList();
        },
        viewZhengc(item){
            this.showMode = "detail"
            this.zhengcId = item.zhengcId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 5);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    background-color: #fff;
    height: auto;
}
.content-container{
    width: 100%;
    margin: auto;
    min-height: calc(100vh - 90px);
    padding-left: 10px;
    padding-top: 5px;
    box-sizing: border-box;
}
.tj-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.tj-item{
    width: auto;
    margin-right: 24px;
    line-height: 30px;
    color: #000;
    cursor: pointer;
    font-size: 16px;
}
.tj-item-active{
    width: auto;
    margin-right: 24px;
    line-height: 30px;
    color: #0d55a4;
    font-weight: bold;
    cursor: pointer;
    font-size: 16px;
}

.right-container{
    width: 100%;
    height: auto;
}
.info-list-container{
    width: 100%;
    height: calc(100vh - 220px)!important;
    margin: auto;
    overflow-x: hidden;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    padding-top: 15px;
    box-sizing: border-box;
}

.zc-item{
    width: 90%;
    height: auto;
    border-bottom: 1px solid #efefef;
    margin-bottom: 10px;
}
.zc-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    color: #101010;
    font-size: 16px;
    cursor: pointer;
}
.zc-title:hover{
    color: #0d55a4!important;
}
.zc-content{
    width: 100%;
    height: auto;
    line-height: 24px;
    color: #9e9e9e;
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 限制在一个块元素显示的文本的行数 */
    -webkit-box-orient: vertical;
    cursor: pointer;
    margin-bottom: 5px;
}
.tag-content{
    width: 100%;
    height: 40px;
    line-height: 40px;
    display: flex;
    margin-bottom: 10px;
}
.tag-type{
    width: auto;
    padding: 0 10px 0 10px;
    margin-right: 20px;
    margin-bottom: 5px;
    color: rgb(95, 137, 198);
    border-width: 1px;
    border-style: solid;
    border-color: rgb(242, 242, 242);
    border-image: initial;
    border-radius: 8px;
    height: 40px;
    line-height: 40px;
}
.tag-time{
    width: auto;
    padding: 0 10px 0 10px;
    color: rgb(95, 137, 198);
    border-width: 1px;
    border-style: solid;
    border-color: rgb(242, 242, 242);
    border-image: initial;
    border-radius: 8px;
    height: 40px;
    line-height: 40px;
}
</style>